// extracted by mini-css-extract-plugin
export var dividerLine = "_4b-0";
export var errorBackground = "_4b-1";